import { Navigate, Route, Routes } from 'react-router-dom';
import ProtectedRoute from './components/ProtectedRoute';
import AppShell from './components/AppShell';
import LoginPage from './pages/LoginPage';
import AuthCallbackPage from './pages/AuthCallbackPage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import FoundationPage from './pages/FoundationPage';
import ActivityPage from './pages/ActivityPage';
import ReportsPage from './pages/ReportsPage';
import TodayPage from './pages/TodayPage';
import AttentionPage from './pages/AttentionPage';
import LeadRecordPage from './pages/LeadRecordPage';
import LeadsPage from './pages/LeadsPage';
import NotALeadPage from './pages/NotALeadPage';
import TrashPage from './pages/TrashPage';
import AdminTeamPage from './pages/AdminTeamPage';
import AdminIntegrationsPage from './pages/AdminIntegrationsPage';
import AdminAuditPage from './pages/AdminAuditPage';
import AdminSettingsPageWithDefaultOffer from './pages/AdminSettingsPageWithDefaultOffer';
import ViewerPlusSettingsPage from './pages/ViewerPlusSettingsPage';
import { useAuth } from './context/AuthContext';
import { isViewerPlus } from './lib/permissions';

function TeamAccessPage(){
  const {role}=useAuth();
  return isViewerPlus(role)?<Navigate to="/" replace/>:<AdminTeamPage/>;
}

function SettingsAccessPage(){
  const {role}=useAuth();
  return isViewerPlus(role)?<ViewerPlusSettingsPage/>:<AdminSettingsPageWithDefaultOffer/>;
}

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/auth/callback" element={<AuthCallbackPage />} />
      <Route path="/auth/reset-password" element={<ResetPasswordPage />} />
      <Route path="/" element={<ProtectedRoute><AppShell /></ProtectedRoute>}>
        <Route index element={<TodayPage />} />
        <Route path="attention" element={<AttentionPage />} />
        <Route path="leads" element={<LeadsPage />} />
        <Route path="leads/not-a-lead" element={<NotALeadPage />} />
        <Route path="leads/:leadId" element={<LeadRecordPage />} />
        <Route path="activity" element={<ActivityPage />} />
        <Route path="reports" element={<ReportsPage />} />
        <Route path="trash" element={<TrashPage />} />
        <Route path="admin/team" element={<TeamAccessPage />} />
        <Route path="admin/integrations" element={<AdminIntegrationsPage />} />
        <Route path="admin/audit" element={<AdminAuditPage />} />
        <Route path="admin/settings" element={<SettingsAccessPage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  );
}
